import { FaArrowLeft } from "react-icons/fa";
import { GiHamburgerMenu } from "react-icons/gi";
import { useEffect } from "react";
import { CalendarDays } from "lucide-react";

import {
 
  Bell
} from "lucide-react";
import {
  RiLogoutCircleRLine,
  RiChatHistoryLine,
  RiStethoscopeLine,
  RiAlarmLine,
  RiHome2Line,
  RiRobot2Line,
  RiUser3Line
} from "react-icons/ri";

import {
  RiNotification3Line,
  RiDeleteBin6Line,
  RiCheckDoubleLine,
} from "react-icons/ri";

import { MdScience, MdOutlineMedication, MdImageSearch ,MdPersonSearch, MdMonitorHeart } from "react-icons/md";
import { useContext, useState } from "react";
import { FaFilePrescription,FaXRay,FaHospitalSymbol  } from "react-icons/fa";
import {RiScan2Line} from "react-icons/ri"
import axios from "axios";

import { useLocation, useNavigate } from "react-router-dom";
import languageContext from "../context/language/languageContext";
import {API_URL,FAST_API_URL} from "../api"

const Navbar = () => {
  const {
    lang,
    setSessionTimeout,
    dataApi,
    setData,
    setAlert,
    setMessage,
    isRightPanel,
    setIsRightPanel,
  } = useContext(languageContext);

  const navigate = useNavigate();
  const location = useLocation();
  const url = location.state?.url || "/";
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isLeftPanel, setIsLeftPanel] = useState(false);
    const [notifications, setNotifications] =
    useState([]);

  const [notificationOpen, setNotificationOpen] =
    useState(false);


  const clearAllNotifications = async () => {
  try {
    const token = localStorage.getItem("token");

    await axios.delete(
      `${API_URL}/patient_notifications/clear-all`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setNotifications([]);
  } catch (error) {
    console.log(error);
  }
};


  const fetchNotifications = async () => {
  try {
    const token = localStorage.getItem("token");

    const response = await axios.post(
      `${API_URL}/patient-notifications`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const data = response.data.notifications || [];

    setNotifications(Array.isArray(data) ? data : []);
  } catch (error) {
    console.error("Notification Error:", error);
  }
};


// =========================================================
// MARK AS READ
// =========================================================

const markAsRead = async (id) => {
  try {
    const token = localStorage.getItem("token");

    await axios.patch(
      `https://www.careplus.gopillz.com/patient_notifications/${id}/read`,
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setNotifications((prev) =>
      prev.map((item) =>
        item.id === id
          ? { ...item, is_read: true }
          : item
      )
    );
  } catch (error) {
    console.error("Mark Read Error:", error);
  }
};


// =========================================================
// DELETE NOTIFICATION
// =========================================================

const deleteNotification = async (id) => {
  try {
    const token = localStorage.getItem("token");

    await axios.delete(
      `https://www.careplus.gopillz.com/patient_notifications/${id}/delete`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setNotifications((prev) =>
      prev.filter((item) => item.id !== id)
    );
  } catch (error) {
    console.error("Delete Notification Error:", error);
  }
};


// =========================================================
// AUTO FETCH
// =========================================================

useEffect(() => {
  fetchNotifications();

  const interval = setInterval(() => {
    fetchNotifications();
  }, 30000);

  return () => clearInterval(interval);
}, []);

  const unreadCount = notifications.filter(
  (n) => !n.is_read
).length;


  const labels = {
    0: {
      searchHospital: "Search Hospitals",
      bookAppointment: "Book Appointment",
      labAppointment: "Lab Appointment",
      setReminder: "Set Reminder",
      buyMedicine: "Buy Medicine",
      medicineInfo: "Medicine Info",
      reminderUpload: "Reminder via Prescription",
      profile: "Profile",
      home: "Home",
      logout: "Logout",
      General_Assistant:"Cancer  Assistant",
      imageAnalysis: "Analyse CT/X ray images",
      labReportAnalysis: "Lab Report Analysis",
      HumanImageAnalysis:"Picture Analysis",
      rppgMonitor: "Heart Rate, SpO₂ & Blood Pressure Monitor", // 🩺 Updated label
      PrescriptionReader:"Your Prescription",
      dailyPlan: "Daily Plan 🩺",
      allappointments:"All Appointments",
      alllab: "All Lab Appointments",
      allMedicineOrders:"All Medicine Orders",


    },
    1: {
      searchHospital: "अस्पताल खोजें",
      bookAppointment: "अपॉइंटमेंट बुक करें",
      labAppointment: "लैब अपॉइंटमेंट",
      setReminder: "रिमाइंडर सेट करें",
      buyMedicine: "दवा खरीदें",
      medicineInfo: "दवा जानकारी",
      reminderUpload: "प्रिस्क्रिप्शन से रिमाइंडर",
      profile: "प्रोफ़ाइल",
      home: "होम",
      logout: "लॉगआउट",
      General_Assistant:"सामान्य सहायक",
      imageAnalysis: "रिपोर्ट विश्लेषण",
      labReportAnalysis: "लैब रिपोर्ट विश्लेषण",
      HumanImageAnalysis:"चित्र विश्लेषण",
      rppgMonitor: "हृदय गति, ऑक्सीजन स्तर (SpO₂) और रक्तचाप मॉनिटर", // 🩺 हिंदी लेबल
      PrescriptionReader:"आपका प्रिस्क्रिप्शन",
      dailyPlan: "दैनिक योजना 🩺",
      allappointments:"सभी अपॉइंटमेंट्स",
      alllab: "सभी लैब बुकिंग्स",
      allMedicineOrders:"सभी दवा ऑर्डर"

      


    },
    2: {
      searchHospital: "ਹਾਸਪਤਾਲ ਖੋਜੋ",
      bookAppointment: "ਮੁਲਾਕਾਤ ਬੁੱਕ ਕਰੋ",
      labAppointment: "ਲੈਬ ਮੁਲਾਕਾਤ",
      setReminder: "ਰੀਮਾਈਂਡਰ ਸੈੱਟ ਕਰੋ",
      buyMedicine: "ਦਵਾਈ ਖਰੀਦੋ",
      medicineInfo: "ਦਵਾਈ ਦੀ ਜਾਣਕਾਰੀ",
      reminderUpload: "ਨੁਸਖੇ ਰਾਹੀਂ ਰੀਮਾਈਂਡਰ",
      profile: "ਪ੍ਰੋਫਾਈਲ",
      home: "ਘਰ",
      logout: "ਲਾਗ ਆਉਟ",
      General_Assistant:"ਸਧਾਰਣ ਸਹਾਇਕ",
      imageAnalysis: "ਰਿਪੋਰਟ ਵਿਸ਼ਲੇਸ਼ਣ",
      labReportAnalysis: "ਲੈਬ ਰਿਪੋਰਟ ਵਿਸ਼ਲੇਸ਼ਣ",
      HumanImageAnalysis:"ਫੋਟੋ ਜਾਂਚ",
      rppgMonitor: "ਦਿਲ ਦੀ ਧੜਕਨ, ਆਕਸੀਜਨ ਪੱਧਰ (SpO₂) ਅਤੇ ਖੂਨ ਦਾ ਦਬਾਅ ਮੋਨੀਟਰ", // 🩺 ਪੰਜਾਬੀ ਲੇਬਲ
      PrescriptionReader:"ਤੁਹਾਡਾ ਪ੍ਰਿਸਕ੍ਰਿਪਸ਼ਨ",
      dailyPlan: "ਰੋਜ਼ਾਨਾ ਯੋਜਨਾ 🩺",
      allappointments:"सभी अपॉइंटमेंट्स",
      alllab: "ਸਾਰੀਆਂ ਲੈਬ ਬੁਕਿੰਗਾਂ",
      allMedicineOrders:"ਸਾਰੇ ਦਵਾਈ ਆਰਡਰ"

    },
  }[lang || 0];

  // const logout = () => {
  //   localStorage.removeItem("token");
  //   localStorage.removeItem("login");
  //   navigate("/");
  // };
  const logout = async () => {
    const token = localStorage.getItem("token");
    const patientId = localStorage.getItem("patient_id"); // make sure this is stored earlier
  
    try {
      if (token && patientId) {
        await axios.post(
          `${API_URL}/delete_cache_alert`, // Replace with actual API endpoint
          { patient_id: patientId },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
      }
    } catch (error) {
      console.error("Cache deletion failed:", error);
      // Optional: Show a toast or alert here
    }
  
    // Clear auth and redirect
    localStorage.removeItem("token");
    localStorage.removeItem("login");
    localStorage.removeItem("patient_id"); // clear patient ID too
    navigate("/"); // or "/" depending on your route
  };

  const handleBackArrowPress = () => navigate(-1)
  const handlehome = () => navigate("/ask");
  const handleprofile = () => navigate("/account");
  const handleBookAppointment = () => navigate("/book_appointment");
  const handlelabAppointment = () => navigate("/lab_book");
  const handlereminderAppointment = () => navigate("/reminder");
  const handleMedicine = () => navigate("/buy_medicine");
  const handleGeneralAssistant = () => navigate("/general_serach");
  const handleMedicineChatbot = () => navigate("/medicine_chat");
  const handleReminderUpload = () => navigate("/reminder_upload");
  const handleImageAnalysis = () => navigate("/image_analysis");
  const handleSearchHospital = () => navigate("/search_hospital");
  const handleLabReportAnalysis=()=> navigate("/lab_report_analysis")
  const handlehumanReportAnalysis=()=>navigate("/medical_image_analyzer")
  const handlerrpd =()=>navigate("/RPPGWebcam")
  const handlePrescriptionAnalysis=()=>navigate("/prescription")
  const handlerDailyplan=()=>navigate("/plan")
  const handlerallappointment=()=>navigate("/all_appointment")
  const handleralllabappointment=()=>navigate("/lab_bookings")
  const handlerallMedicineOrders=()=>navigate("/medicine_bookings")


  const navButton = (onClick, label, Icon, color = "blue") => (
    <button
  onClick={onClick}
  className={`mt-1 bg-${color}-600 700 text-white px-3 py-2 rounded-lg text-xs font-semibold shadow-md hover:scale-105 hover:shadow-lg transition-all duration-300 flex items-center gap-2 whitespace-nowrap min-w-[140px] justify-center`}
>
  <Icon size={10} />
  {label}
</button>

  );

  const secondaryButton = (onClick, label, Icon, color = "blue") => (
    <button
      onClick={onClick}
      className={`bg-${color}-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-${color}-700 transition duration-300 flex items-center gap-2`}
    >
      <Icon className="text-sky-700" size={18} />
      {label}
    </button>
  );

  const mobilenavButton = (onClick, label, Icon) => (
    <button
      onClick={onClick}
      className="bg-blue-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-blue-700 transition duration-300 flex items-center gap-2"
    >
      <Icon size={18} />
      <span>{label}</span>
    </button>
  );

  const mobilesecondaryButton = (onClick, label, Icon) => (
    <button
      onClick={onClick}
      className="bg-sky-600 text-white px-4 py-2 rounded-lg text-sm font-semibold shadow-md hover:bg-sky-700 transition duration-300 flex items-center gap-2"
    >
      <Icon size={18} />
      <span>{label}</span>
    </button>
  );

  return (
    <div className="bg-gradient-to-br from-teal-500 via-green-400 to-blue-300 w-full h-[70px] md:h-[80px] flex items-center justify-between px-6 shadow-lg">
      <div className="flex items-center space-x-4">
        <div
          className="w-[40px] h-[40px] bg-gray-700 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-blue-600 transition"
          onClick={handleBackArrowPress}
        >
          <FaArrowLeft size="1.4rem" />
        </div>

        {localStorage.getItem("login") && location.pathname.includes("/ask") && (
          <div
            className="md:hidden w-[40px] h-[40px] bg-gray-700 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-blue-600 transition"
            onClick={() => {
              setIsRightPanel(false);
              setIsLeftPanel(!isLeftPanel);
            }}
          >
            <RiChatHistoryLine size="1.4rem" />
          </div>
        )}
      </div>

      <div className="hidden md:flex flex-wrap justify-center gap-2">
        {location.pathname.includes("/ask") && (
          <>
            {navButton(handleBookAppointment, labels.bookAppointment, RiStethoscopeLine)}
            {navButton(handlelabAppointment, labels.labAppointment, MdScience)}
            {navButton(handlereminderAppointment, labels.setReminder, RiAlarmLine)}
            {navButton(handleMedicine, labels.buyMedicine, MdOutlineMedication)}
            {navButton(handleGeneralAssistant, labels.General_Assistant, RiRobot2Line)}
            {navButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
            {navButton(handleReminderUpload, labels.reminderUpload, FaFilePrescription)}
            {navButton(handleImageAnalysis, labels.imageAnalysis, MdImageSearch)}
            {navButton(handleLabReportAnalysis, labels.labReportAnalysis, MdScience)}
            {navButton(handlehumanReportAnalysis, labels.HumanImageAnalysis, MdPersonSearch)}
            {navButton(handleSearchHospital, labels.searchHospital, FaHospitalSymbol)}
            
            {navButton(handlerrpd, labels.rppgMonitor,MdMonitorHeart )}
            {navButton(handlePrescriptionAnalysis, labels.PrescriptionReader, FaFilePrescription)}
            {navButton(handlerDailyplan, labels.dailyPlan, FaFilePrescription)}
            {navButton(handlerallappointment,labels.allappointments,CalendarDays)}
            {navButton(handleralllabappointment,labels.alllab,CalendarDays)}
            {navButton(handlerallMedicineOrders,labels.allMedicineOrders,CalendarDays)}

            {navButton(handleprofile, labels.profile, RiUser3Line)}
          </>
        )}


        {[
          "medicine_bookings",
          "lab_bookings",
          "all_appointment",
          "/prescription",
          "/RPPGWebcam",
          "/medical_image_analyzer",
          "/search_hospital",
          "/book_appointment",
          "/lab_book",
          "/reminder",
          "/buy_medicine",
          "/general_serach",
          "/checklist",
          "/account",
          "/reminder_upload",
          "/image_analysis",
          "/lab_report_analysis",
          "/plan"
        ].some((path) => location.pathname.includes(path)) && (
          <>
            {navButton(handlehome, labels.home, RiHome2Line)}
            {secondaryButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
           
            {!location.pathname.includes("/image_analysis") &&
            navButton(handleImageAnalysis, labels.imageAnalysis, MdImageSearch)}
            {!location.pathname.includes("/lab_report_analysis") &&
            navButton(handleLabReportAnalysis, labels.labReportAnalysis, MdScience)}
            {!location.pathname.includes("/plan") &&
            navButton(handlerDailyplan, labels.dailyPlan, FaFilePrescription)}
            {/* {navButton(handlerrpd, labels.rppgMonitor, handlerrpd)} */}
             {navButton(handleprofile, labels.profile, RiUser3Line)}
          </>
        )}
        

        {["/medicine_chat"].some((path) => location.pathname.includes(path)) && (
          <>
            {navButton(handlehome, labels.home, RiHome2Line)}
          
            {navButton(handleImageAnalysis, labels.imageAnalysis, MdImageSearch)}
            {navButton(handleLabReportAnalysis, labels.labReportAnalysis, MdScience)}
            {navButton(handlehumanReportAnalysis, labels.HumanImageAnalysis, MdPersonSearch)}
            {navButton(handlerrpd, labels.rppgMonitor, MdMonitorHeart)}
            {navButton(handlerDailyplan, labels.dailyPlan, FaFilePrescription)}
            {navButton(handlerallappointment,labels.allappointments,CalendarDays)}
            {navButton(handleralllabappointment,labels.alllab,CalendarDays)}
             {navButton(handlerallMedicineOrders,labels.allMedicineOrders,CalendarDays)}
  {navButton(handleprofile, labels.profile, RiUser3Line)}
          </>
        )}
      </div>

      <div className="md:hidden flex items-center space-x-4">
        <button
          onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          className="w-[40px] h-[40px] bg-gray-700 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-blue-600 transition"
        >
          <GiHamburgerMenu size="1.5rem" />
        </button>
      </div>

      <div className="hidden md:flex items-center space-x-4">



<div className="relative">

  {/* NOTIFICATION BUTTON */}

  <button
    onClick={() =>
      setNotificationOpen(!notificationOpen)
    }
    className="
      relative
      w-[44px] h-[44px]
      rounded-2xl
      bg-white/90
      backdrop-blur-lg
      shadow-lg
      border border-white/40
      hover:scale-105
      transition-all duration-300
      flex items-center justify-center
    "
  >
    <RiNotification3Line
      size={22}
      className="text-gray-700"
    />

    {unreadCount > 0 && (
      <div
        className="
          absolute
          -top-1
          -right-1
          bg-gradient-to-r
          from-red-500
          to-pink-500
          text-white
          text-[10px]
          font-bold
          min-w-[20px]
          h-[20px]
          px-1
          rounded-full
          flex items-center justify-center
          shadow-md
          animate-pulse
        "
      >
        {unreadCount}
      </div>
    )}
  </button>

  {/* ====================================================== */}
  {/* MODERN DROPDOWN */}
  {/* ====================================================== */}

  {notificationOpen && (
    <div
      className="
        absolute right-0 mt-4
        w-[350px]
        md:w-[420px]
        bg-white/95
        backdrop-blur-2xl
        rounded-3xl
        shadow-[0_20px_60px_rgba(0,0,0,0.18)]
        border border-white/30
        overflow-hidden
        z-[99999]
        animate-in fade-in zoom-in duration-300
      "
    >

      {/* HEADER */}

      <div
        className="
          px-5 py-4
          bg-gradient-to-r
          from-blue-50
          via-white
          to-cyan-50
          border-b
        "
      >

        <div className="flex items-center justify-between">

          {/* LEFT */}

          <div>

            <div className="flex items-center gap-2">

              <div
                className="
                  w-10 h-10
                  rounded-2xl
                  bg-blue-100
                  flex items-center justify-center
                "
              >
                <RiNotification3Line
                  className="text-blue-600"
                  size={20}
                />
              </div>

              <div>
                <h3 className="font-bold text-gray-800 text-sm">
                  Notifications
                </h3>

                <p className="text-xs text-gray-500">
                  {unreadCount} unread messages
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT */}

          {notifications.length > 0 && (
            <button
              onClick={clearAllNotifications}
              className="
                flex items-center gap-1
                bg-red-50
                hover:bg-red-100
                text-red-600
                px-3 py-2
                rounded-xl
                text-xs
                font-semibold
                transition
              "
            >
              <RiDeleteBin6Line size={15} />
              Clear All
            </button>
          )}
        </div>
      </div>

      {/* BODY */}

      <div className="max-h-[500px] overflow-y-auto">

        {notifications.length === 0 ? (

          <div className="p-10 flex flex-col items-center justify-center">

            <div
              className="
                w-20 h-20
                rounded-full
                bg-blue-50
                flex items-center justify-center
                mb-4
              "
            >
              <RiCheckDoubleLine
                size={34}
                className="text-blue-500"
              />
            </div>

            <h3 className="font-semibold text-gray-700">
              All Caught Up
            </h3>

            <p className="text-xs text-gray-400 mt-1">
              No new notifications available
            </p>
          </div>

        ) : (

          notifications.map((item) => (

            <div
              key={item.id}
              className={`
                group
                relative
                px-5 py-4
                border-b border-gray-100
                hover:bg-gradient-to-r
                hover:from-blue-50/70
                hover:to-cyan-50/40
                transition-all duration-300
                ${
                  item.is_read
                    ? "bg-gray-50/70 opacity-80"
                    : "bg-white"
                }
              `}
            >

              <div className="flex gap-3">

                {/* ICON */}

                <div
                  className={`
                    mt-1
                    w-11 h-11
                    rounded-2xl
                    flex items-center justify-center
                    ${
                      item.notification_type ===
                      "doctor_confirmed"
                        ? "bg-green-100"
                        : item.notification_type ===
                          "doctor_rejected"
                        ? "bg-red-100"
                        : "bg-yellow-100"
                    }
                  `}
                >
                  <RiNotification3Line
                    size={20}
                    className={`
                      ${
                        item.notification_type ===
                        "doctor_confirmed"
                          ? "text-green-600"
                          : item.notification_type ===
                            "doctor_rejected"
                          ? "text-red-600"
                          : "text-yellow-600"
                      }
                    `}
                  />
                </div>

                {/* CONTENT */}

                <div
                  className="flex-1 cursor-pointer"
                  onClick={() => {

                    if (!item.is_read) {
                      markAsRead(item.id);
                    }

                    console.log(item, "item")
                    navigate(item.route);

                    setNotificationOpen(false);
                  }}
                >

                  {/* TOP */}

                  <div className="flex items-center justify-between">

                    <h4 className="font-semibold text-sm text-gray-800">
                      {item.title}
                    </h4>

                    {!item.is_read && (
                      <div
                        className="
                          w-2.5 h-2.5
                          bg-blue-500
                          rounded-full
                          animate-pulse
                        "
                      />
                    )}
                  </div>

                  {/* MESSAGE */}

                  <p className="text-xs text-gray-600 mt-1 leading-relaxed">
                    {item.message}
                  </p>

                  {/* TAG */}

                  <div className="mt-3">

                    {item.notification_type ===
                      "doctor_confirmed" && (
                      <span
                        className="
                          bg-green-100
                          text-green-700
                          text-[10px]
                          px-3 py-1
                          rounded-full
                          font-semibold
                        "
                      >
                        Appointment Confirmed
                      </span>
                    )}

                    {item.notification_type ===
                      "doctor_rejected" && (
                      <span
                        className="
                          bg-red-100
                          text-red-700
                          text-[10px]
                          px-3 py-1
                          rounded-full
                          font-semibold
                        "
                      >
                        Appointment Rejected
                      </span>
                    )}

                    {item.notification_type ===
                      "slot_changed" && (
                      <span
                        className="
                          bg-yellow-100
                          text-yellow-700
                          text-[10px]
                          px-3 py-1
                          rounded-full
                          font-semibold
                        "
                      >
                        Slot Updated
                      </span>
                    )}
                  </div>
                </div>

                {/* DELETE */}

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    deleteNotification(item.id);
                  }}
                  className="
                    opacity-0
                    group-hover:opacity-100
                    transition-all
                    duration-300
                    w-9 h-9
                    rounded-xl
                    hover:bg-red-100
                    flex items-center justify-center
                    text-red-500
                  "
                >
                  <RiDeleteBin6Line size={18} />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  )}
</div>

  {/* LOGOUT */}

  <div
    className="w-[44px] h-[44px] bg-red-600 text-white rounded-full flex justify-center items-center cursor-pointer hover:bg-red-700 transition"
    onClick={logout}
  >
    <RiLogoutCircleRLine size="1.4rem" />
  </div>
</div>

      
      {isMobileMenuOpen && (
        <div className="fixed top-[70px] right-4 w-[85%] max-w-xs bg-white shadow-xl rounded-xl z-[9999] p-4 flex flex-col space-y-3">
          {location.pathname.includes("/ask") && (
            <>
              {mobilenavButton(handleBookAppointment, labels.bookAppointment, RiStethoscopeLine)}
              {mobilenavButton(handlelabAppointment, labels.labAppointment, MdScience)}
              {mobilenavButton(handlereminderAppointment, labels.setReminder, RiAlarmLine)}
              {mobilenavButton(handleMedicine, labels.buyMedicine, MdOutlineMedication)}
              {mobilenavButton(handleGeneralAssistant, labels.General_Assistant, RiRobot2Line)}
              {mobilenavButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
              {mobilenavButton(handleReminderUpload, labels.reminderUpload, FaFilePrescription)}
              {mobilenavButton(handleImageAnalysis, labels.imageAnalysis, MdImageSearch)}
              {mobilenavButton(handleLabReportAnalysis, labels.labReportAnalysis, MdScience)}
              {mobilenavButton(handlehumanReportAnalysis, labels.HumanImageAnalysis, MdPersonSearch)}
              {mobilenavButton(handlePrescriptionAnalysis, labels.PrescriptionReader, FaFilePrescription)}

              {mobilenavButton(handleSearchHospital, labels.searchHospital, FaHospitalSymbol)}
            
              {mobilenavButton(handlerrpd, labels.rppgMonitor, MdMonitorHeart)}
              {mobilenavButton(handlerDailyplan, labels.dailyPlan, FaFilePrescription)}
              {mobilenavButton(handlerallappointment,labels.allappointments,CalendarDays)}
            {mobilenavButton(handleralllabappointment,labels.alllab,CalendarDays)}
             {mobilenavButton(handlerallMedicineOrders,labels.allMedicineOrders,CalendarDays)}
  {mobilenavButton(handleprofile, labels.profile, RiUser3Line)}
            </>
          )}

          {[
            "medicine_bookings",
            "lab_bookings",
            "/all_appointment",
            "/prescription",
            "/RPPGWebcam",
            "/medical_image_analyzer",
            "/search_hospital",
            "/book_appointment",
            "/lab_book",
            "/reminder",
            "/buy_medicine",
            "/general_serach",
            "/checklist",
            "/account",
            "/reminder_upload",
            "/image_analysis",
            "/lab_report_analysis",
            "/plan"
          ].some((path) => location.pathname.includes(path)) && (
            <>
            {/* {mobilenavButton(handlerrpd, labels.rppgMonitor, handlerrpd)} */}
              {mobilenavButton(handlehome, labels.home, RiHome2Line)}
              {mobilesecondaryButton(handleMedicineChatbot, labels.medicineInfo, MdOutlineMedication)}
             
              {!location.pathname.includes("/image_analysis") &&
              mobilenavButton(handleImageAnalysis, labels.imageAnalysis, MdImageSearch)}
              {!location.pathname.includes("/lab_report_analysis") &&
              mobilenavButton(handleLabReportAnalysis, labels.labReportAnalysis, MdScience)}
              {!location.pathname.includes("/plan") &&mobilenavButton(handlerDailyplan, labels.dailyPlan, FaFilePrescription)}
 {mobilenavButton(handleprofile, labels.profile, RiUser3Line)}

            </>
            
          )}



          {["/medicine_chat"].some((path) => location.pathname.includes(path)) && (
            <>
            {mobilenavButton(handlerrpd, labels.rppgMonitor, handlerrpd)}
              {mobilenavButton(handlehome, labels.home, RiHome2Line)}
              
              {mobilenavButton(handleImageAnalysis, labels.imageAnalysis, MdImageSearch)}
              {mobilenavButton(handleLabReportAnalysis, labels.labReportAnalysis, MdScience)}
              {mobilenavButton(handlehumanReportAnalysis, labels.HumanImageAnalysis, MdPersonSearch)}
              {mobilenavButton(handlerrpd, labels.rppgMonitor, MdMonitorHeart)}
              {mobilenavButton(handlerDailyplan, labels.dailyPlan, FaFilePrescription)}
               {mobilenavButton(handlerallappointment,labels.allappointments,CalendarDays)}
            {mobilenavButton(handleralllabappointment,labels.alllab,CalendarDays)}
             {mobilenavButton(handlerallMedicineOrders,labels.allMedicineOrders,CalendarDays)}
             
{mobilenavButton(handleprofile, labels.profile, RiUser3Line)}

            </>
          )}

          {navButton(logout, labels.logout, RiLogoutCircleRLine, "red")}
        </div>
      )}
    </div>
  );
};

export default Navbar;
